import IAdminLoginResultDTO from "../models/DTO/AdminDTO/IAdminLoginResultDTO";

const saveAdminLogin = (data: IAdminLoginResultDTO): void => {
    try {
        const adminData = JSON.stringify(data);
        localStorage.setItem("adminLogin", adminData);
    } catch (err) {
        console.error("Error saving admin login data:", err);
    }
};

const getAdminLogin = (): IAdminLoginResultDTO | null => {
    try {
        const data = localStorage.getItem("adminLogin");
        return data ? JSON.parse(data) : null;
    } catch (err) {
        console.error("Error getting admin login data:", err);
        return null;
    }
};

const clearAdminLogin = (): void => {
    try {
        localStorage.removeItem("adminLogin");
    } catch (err) {
        console.error("Error clearing admin login data:", err);
    }
};

const AdminService = {
    saveAdminLogin,
    getAdminLogin,
    clearAdminLogin,
};

export default AdminService;
